module.exports = __webpack_public_path__ + "static/media/icon3.55b33399.svg";